import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GetService } from 'src/app/Services/get.service';
import { URLs } from 'src/app/URLs';

@Component({
  selector: 'app-inquiry-details',
  templateUrl: './inquiry-details.component.html',
  styleUrls: ['./inquiry-details.component.scss']
})
export class InquiryDetailsComponent implements OnInit, OnDestroy {
  inquiryId;
  singleInquiry;
  InquiriesUrl=URLs.inquiries;
  inquiryDetailsSubscription = new Subscription();
  constructor(private service:GetService, private activatedRoute:ActivatedRoute, private spinner:NgxSpinnerService) {
    this.activatedRoute.params.subscribe((recivedID) =>{
      this.inquiryId = recivedID.id;
     this.inquiryDetailsSubscription = this.service.getById(this.InquiriesUrl,this.inquiryId).subscribe((inq) =>{
        this.singleInquiry = inq.response.data;
        

      });

    })
   }

  ngOnInit(): void {
    this.spinner.show()

    setTimeout(() => {
      this.spinner.hide()
    }, 1000);
  }
ngOnDestroy(): void {
 this.inquiryDetailsSubscription.unsubscribe();

}

}
